import { useQuery } from "react-query";
import api from "../common/axios";
import { Endpoints } from "../common/constants";
import { reportError } from "../crashlytics";

export function useGetDepartments() {
    return useQuery(
        Endpoints.Departmets.GetDepartmets,
        () =>
            api
                .get(Endpoints.Departmets.GetDepartmets)

                .then((response) => response?.data?.data),
        {
            onError: (error) => {
                reportError("useGetDepartments: useQuery: onError: error", error);
            },
        }
    );
}
